/** Fired after server cart changes so shell (e.g. header badge) can refetch. */
export const CART_CHANGED_EVENT = "leMemePrix:cartChanged";

export function dispatchCartChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(CART_CHANGED_EVENT));
  }
}
